module.exports = __webpack_public_path__ + "static/media/onboarding-1_3x.4c849a88.png";